import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { testId } from 'ui-components/services/testid-service';
import { ShipDate } from './ship-date';
import { ShipFrom } from './ship-from';
import Weight from '../../../../../fulfillment-planner/weight/weight';
import { ShippingService } from './shipping-service';
import { RequestedService } from './requested-service';
import { Confirmation } from './confirmation';
import { Insurance } from './insurance';
import { Package } from './package';
import Size from '../../../../../fulfillment-planner/dimensions/size';
import Presets from '../../../../../fulfillment-planner/presets/container';
import Error from '../../../../../fulfillment-planner/error';
import RateAndCreateLabel from '../../../../../fulfillment-planner/rate-and-create-label';
import ShippingDefaultButton from '../../../../../fulfillment-planner/shipping-default-button/index';
import style from './style.module.less';

const sizeAndWeightClassNames = {
  label: style.label,
  'size-input': style['size-input'],
  'weight-input': style['weight-input'],
  weight: style.weight,
  scale: style.scale,
  container: style['size-and-weight-container'],
};

export const ShipmentDetailsFulfillmentConfiguration = ({ fulfillmentPlanId }) => {
  return (
    <div className={style['csw-wrapper']} {...testId('csw')}>
      <div className={style.header}>
        <div className={style['header-title']}>
          <FormattedMessage defaultMessage='Shipping' description='shipmentDetails.fulfillmentConfiguration.header' id='kFpMaT' />
        </div>
        <Presets fulfillmentPlanId={fulfillmentPlanId} />
      </div>
      <div className={style['shipment-details-fulfillment-configuration']}>
        <ShipDate />
        <RequestedService fulfillmentPlanId={fulfillmentPlanId} />
        <ShipFrom fulfillmentPlanId={fulfillmentPlanId} />
        <Weight classNames={sizeAndWeightClassNames} showScale shrinkable />
        <ShippingService fulfillmentPlanId={fulfillmentPlanId} />
        <Package fulfillmentPlanId={fulfillmentPlanId} />
        <Size classNames={sizeAndWeightClassNames} fulfillmentPlanId={fulfillmentPlanId} shrinkable />
        <Confirmation fulfillmentPlanId={fulfillmentPlanId} />
        <Insurance fulfillmentPlanId={fulfillmentPlanId} />
        <Error className={style['error-container']} />
      </div>
      <ShippingDefaultButton fulfillmentPlanId={fulfillmentPlanId} />
      <RateAndCreateLabel fulfillmentPlanId={fulfillmentPlanId} />
    </div>
  );
};

ShipmentDetailsFulfillmentConfiguration.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
